export default __webpack_public_path__ + "static/media/fish-exemple.a51f251e.png";